import React from 'react'
import { currencyFormatWithDisplay } from '../../../../../main/configs/currency'
import { If } from '../../../../components/if/if'
import { useOrder } from '../../../../contexts/order'
import { ServiceCharge } from '../../../../enums/stablishment-tables'
import { formatDate } from '../../../../helpers/helper-date'
import { orderStatusLabel, serviceChargeLabel } from '../../../../helpers/helper-order'
import { formatCurrency } from '../../../../helpers/helper-price'

import {
  Container,
  OrderInfoFooter,
  TaxWrapper,
  Total,
} from './styles'

const OrderPad = () => {
  const {
    orderPad,
    amountCustomer,
    setAmountCustomerIsOpen,
    serviceCharge,
    serviceChargeType,
    subtotal,
    total,
    currentOrderPadCard,
  } = useOrder()

  if (!orderPad || !currentOrderPadCard) return <></>

  const { hasServiceCharge } = orderPad.stablishmentTable

  const orders = currentOrderPadCard.status === 0
    ? orderPad.orders.filter((order) => ![8, 9].includes(order.status))
    : orderPad.orders.filter((order) => order.status === 8)

  return (
    <Container>
      <table>
        <thead>
          <tr>
            <th>Código</th>
            <th>Itens</th>
            <th>Qtd.</th>
            <th>Observação</th>
            <th>Status</th>
            <th>Horário</th>
            <th>Valor</th>
          </tr>
        </thead>
        <tbody>
          {
          orders.map((order) => (
            <tr key={order.code}>
              <td>{`#${order.code}`}</td>
              <td>{order.product.name}</td>
              <td>{order.amount}</td>
              <td>
                <ul>
                  <If condition={order.observation !== ''}>
                    <li>{order.observation}</li>
                  </If>

                  <If condition={order.observation === '' && order?.preferenceItems?.length <= 0}>
                    <li>Sem observações</li>
                  </If>

                  <If condition={order?.preferenceItems}>
                    {
                      order?.preferenceItems?.split(',').map((pi: any) => (
                        <li key={pi}>{pi}</li>
                      ))
                    }
                  </If>
                </ul>
              </td>
              <td>{orderStatusLabel[(order.status as 1 | 2 | 3 | 4 | 5 | 6 | 7 | 8)]}</td>
              <td>{formatDate(order.createdAt, 'HH:mm')}</td>
              <td className="price">
                {
                  formatCurrency(Number(order.product.price), currencyFormatWithDisplay, 'BRL')
                }
              </td>
            </tr>
          ))
        }
        </tbody>
      </table>

      <OrderInfoFooter>
        <If condition={hasServiceCharge}>
          <p style={{ marginBottom: '15px' }}>
            <strong>Subtotal</strong>
            {formatCurrency(total, currencyFormatWithDisplay, 'BRL')}
          </p>
        </If>
        <If condition={hasServiceCharge}>
          <TaxWrapper>
            <p>
              {serviceChargeLabel[(serviceChargeType as 0 | 1 | 2)]}

              <If condition={serviceChargeType === ServiceCharge.COVER}>
                {
                amountCustomer
                  ? ` (${amountCustomer})`
                  : ' (individual)'
              }
              </If>
              <em>
                {
                ((serviceChargeType === ServiceCharge.COVER && amountCustomer)
                || (serviceChargeType !== ServiceCharge.COVER
                  && hasServiceCharge))
                && formatCurrency(serviceCharge, currencyFormatWithDisplay, 'BRL')
              }
              </em>
            </p>
            <If condition={!amountCustomer && serviceChargeType === ServiceCharge.COVER}>
              <button
                type="button"
                onClick={() => setAmountCustomerIsOpen(true)}
              >
                Confirmar quantidade de pessoas
              </button>
            </If>
          </TaxWrapper>
        </If>
        <Total>
          <strong>Total</strong>
          {formatCurrency(subtotal, currencyFormatWithDisplay, 'BRL')}
        </Total>
        <If condition={!amountCustomer
            && hasServiceCharge
            && serviceChargeType === ServiceCharge.COVER}
        >
          <span>
            *O valor total será recalculado depois que a quantidade de pesssoas forem apresentadas
          </span>
        </If>
      </OrderInfoFooter>
    </Container>
  )
}

export default OrderPad
